import cn from "@/lib/cn";

interface InfoCardProps {
  className?: string;
  children: React.ReactNode;
}

export function InfoCard({ className, children }: InfoCardProps) {
  return (
    <div
      className={cn(
        "rounded-[14px] bg-white shadow-[0_1px_3px_rgba(0,0,0,0.04),0_0_0_1px_rgba(0,0,0,0.03)]",
        className,
      )}
    >
      {children}
    </div>
  );
}

interface InfoCardValueProps {
  className?: string;
  children: React.ReactNode;
}

export function InfoCardValue({ className, children }: InfoCardValueProps) {
  return (
    <span className={cn("text-[13px] font-semibold text-[#111827]", className)}>
      {children}
    </span>
  );
}

interface InfoCardMutedProps {
  className?: string;
  children: React.ReactNode;
}

export function InfoCardMuted({ className, children }: InfoCardMutedProps) {
  return (
    <span className={cn("text-[13px] font-medium text-[#6B7280]", className)}>
      {children}
    </span>
  );
}

interface InfoCardHeaderProps {
  title: string;
  right?: React.ReactNode;
}

export function InfoCardHeader({ title, right }: InfoCardHeaderProps) {
  return (
    <div className="flex items-center justify-between border-b border-[#F3F4F6] px-5 py-4">
      <span className="text-[13px] font-semibold text-[#374151]">{title}</span>
      {right}
    </div>
  );
}
